const getErrorTip = (i18n) => (eCode) => {
  if (i18n.t(eCode) === eCode) {
    return `${i18n.t('error_code')}: ${eCode}`;
  }
  return i18n.t(eCode);
};

export default getErrorTip;
